"use client";

import { c as _c } from "react/compiler-runtime";
import { getCreateWaveNextStep, getCreateWavePreviousStep } from "@/helpers/waves/create-wave.helpers";
import type { CreateWaveConfig, CreateWaveStep } from "@/types/waves.types";
import CreateWaveBackStep from "./CreateWaveBackStep";
import CreateWaveNextStep from "./CreateWaveNextStep";
export default function CreateWaveActions(t0) {
  const $ = _c(20);
  const {
    config,
    step,
    submitting,
    setStep,
    onComplete
  } = t0;
  let t1;
  if ($[0] !== config.overview.type || $[1] !== onComplete || $[2] !== setStep || $[3] !== step) {
    t1 = () => {
      const nextStep = getCreateWaveNextStep({
        step,
        waveType: config.overview.type
      });
      if (nextStep !== null) {
        setStep(nextStep, "forward");
        return;
      }
      onComplete();
    };
    $[0] = config.overview.type;
    $[1] = onComplete;
    $[2] = setStep;
    $[3] = step;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onNextStep = t1;
  let t2;
  if ($[5] !== config.overview.type || $[6] !== step) {
    t2 = getCreateWavePreviousStep({
      step,
      waveType: config.overview.type
    });
    $[5] = config.overview.type;
    $[6] = step;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const previousStep = t2;
  let t3;
  if ($[8] !== previousStep || $[9] !== setStep) {
    t3 = previousStep !== null && <CreateWaveBackStep onPreviousStep={() => setStep(previousStep, "backward")} />;
    $[8] = previousStep;
    $[9] = setStep;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="-tw-ml-6">{t3}</div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== onNextStep || $[14] !== step || $[15] !== submitting) {
    t5 = <div className="tw-ml-auto"><CreateWaveNextStep onClick={onNextStep} disabled={false} step={step} submitting={submitting} /></div>;
    $[13] = onNextStep;
    $[14] = step;
    $[15] = submitting;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t4 || $[18] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-4">{t4}{t5}</div>;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}